import { render, staticRenderFns } from "./Audit-Logs.vue?vue&type=template&id=fb4d906a&scoped=true"
import script from "./Audit-Logs.vue?vue&type=script&lang=js"
export * from "./Audit-Logs.vue?vue&type=script&lang=js"
import style0 from "./Audit-Logs.vue?vue&type=style&index=0&id=fb4d906a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4d906a",
  null
  
)

export default component.exports